import type {ReactElement} from 'react';
import {CircularProgressLoader} from '@Components/circular-progress-loader';

export function AddItemPanelLoading(): ReactElement<any> | null {
  return (
    <div className="_full-width _full-height flex-center">
      <CircularProgressLoader classes="spacing-m-0" />
    </div>
  );
}
